module.exports = __webpack_public_path__ + "img/ziggurat64_ua.3b42181c.webp";